/* eslint quotes: 0 */

let __CLIENT_NAME__ = "SWM";

let messages = {

	'fr-FR': {
		login: "Connexion",
		recrutement: "Recrutement",
		communication: "Communication",
		reportage: "Reportage",
		temoignage: "Témoignages",
		interview: "Interview",
		story: "Story",
		contenu_neutre: "Contenu neutre",

		communication_cci: "Communication CCI",
		workin_salorge: "Work'in Salorge",
		international_ouest_club: "International Ouest Club",

		current_lang: "fr",
		date_locale: "fr-FR",
		new_project_image: "./static/images/new.png",

		months: {
			1: "janvier",
			2: "février",
			3: "mars",
			4: "avril",
			5: "mai",
			6: "juin",
			7: "juillet",
			8: "août",
			9: "septembre",
			10: "octobre",
			11: "novembre",
			12: "décembre",
		},

		StepsList: {
			titre: "Titre de la vidéo",

			intertitle: "Intertitre",
			intertitrage: "Intertitrage",
			intertitle_1: "Intertitre 1",
			intertitrage_1: "Intertitre 1",
			intertitle_2: "Intertitre 2",
			intertitrage_2: "Intertitre 2",
			intertitle_3: "Intertitre 3",
			intertitrage_3: "Intertitre 3",
			intertitle_4: "Intertitre 4",
			intertitrage_4: "Intertitre 4",
			intertitle_5: "Intertitre 5",
			intertitrage_5: "Intertitre 5",
			intertitle_6: "Intertitre 6",
			intertitrage_6: "Intertitre 6",
			intertitrage_7: "Intertitre 7",
			intertitrage_8: "Intertitre 8",
			intertitrage_9: "Intertitre 9",

			interview: "Interview",
			interview_1: "Interview 1",
			interview_2: "Interview 2",
			interview_3: "Interview 3",
			interview_4: "Interview 4",
			interview_5: "Interview 5",
			interview_6: "Interview 6",
			interview_7: "Interview 7",
			interview_8: "Interview 8",
			interview_9: "Interview 9",

			ambiance: "Plan d'ambiance",
			ambiance_1: "Plan d'ambiance 1",
			ambiance_2: "Plan d'ambiance 2",
			ambiance_3: "Plan d'ambiance 3",
			ambiance_4: "Plan d'ambiance 4",
			ambiance_5: "Plan d'ambiance 5",
			ambiance_6: "Plan d'ambiance 6",
			ambiance_7: "Plan d'ambiance 7",
			ambiance_8: "Plan d'ambiance 8",
			ambiance_9: "Plan d'ambiance 9",

			infographie: "Infographie",
			infographie_2: "Infographie 2",
			infographic_1: "Infographie",
			infographic_2: "Infographie 2",

			plan_illustration: "Plan d'illustration",
			plan_illustration_1: "Plan d'illustration 1",
			plan_illustration_2: "Plan d'illustration 2",
			plan_illustration_3: "Plan d'illustration 3",
			plan_illustration_4: "Plan d'illustration 4",
			plan_illustration_5: "Plan d'illustration 5",
			plan_illustration_6: "Plan d'illustration 6",
			plan_illustration_7: "Plan d'illustration 7",
			plan_illustration_8: "Plan d'illustration 8",
			plan_illustration_9: "Plan d'illustration 9",

			plan_ambiance: "Plan d'ambiance",
			plan_ambiance_1: "Plan d'ambiance 1",
			plan_ambiance_2: "Plan d'ambiance 2",
			plan_ambiance_3: "Plan d'ambiance 3",
			plan_ambiance_4: "Plan d'ambiance 4",
			plan_ambiance_5: "Plan d'ambiance 5",
			plan_ambiance_6: "Plan d'ambiance 6",
			plan_ambiance_7: "Plan d'ambiance 7",
			plan_ambiance_8: "Plan d'ambiance 8",
			plan_ambiance_9: "Plan d'ambiance 9",

			question: "Question",
			question_1: "Question 1",
			question_2: "Question 2",
			question_3: "Question 3",
			question_4: "Question 4",
			question_5: "Question 5",
			question_6: "Question 6",
			question_7: "Question 7",
			question_8: "Question 8",
			question_9: "Question 9",

			reponse: "Réponse",
			reponse_1: "Réponse 1",
			reponse_2: "Réponse 2",
			reponse_3: "Réponse 3",
			reponse_4: "Réponse 4",
			reponse_5: "Réponse 5",
			reponse_6: "Réponse 6",
			reponse_7: "Réponse 7",
			reponse_8: "Réponse 8",
			reponse_9: "Réponse 9",

			images: "Images",
			images_1: "Images 1",
			images_2: "Images 2",
			images_3: "Images 3",
			images_4: "Images 4",
			images_5: "Images 5",
			images_6: "Images 6",
			images_7: "Images 7",
			images_8: "Images 8",
			images_9: "Images 9",

			signature: "Choix signature",
			keynumber: "Chiffres clés",
			a_retenir: "À retenir",
			ce_quil_faut_retenir: "Ce qu'il faut retenir",
			qui_communique: "Qui communique ?",

			environnement_de_linterview: "Environnement de l'interview (optionnel)",
			second_ambiance: "Plan d'ambiance (optionnel)",
			final_interview: "Interview de fin (optionnel)",

			Music: "Musique",
			music: "Musique",
			Watermark: "Watermark (optionnel)",
			Credits: "Credits",
			intro: "Intro",
			outro: "Outro",
			Ambiance_keywords: "Mots clés (optionnel)",

			Final: "Finaliser",
		},

		lang: {
			fr: "Français",
			en: "Anglais",
			es: "Espagnol",
			false: "Sans sous-titres",
		},

		Account: {
			contact: "Contacter",
			add_user: "Créer un nouveau compte",
		},

		Dashboard: {
			project_list: "Liste vidéo",
			name: "Tableau de bord",
			labelImageRights: "Droit à l'image",
		},

		Navbar: {
			video_name: "Nom de votre vidéo",
		},

		Menu: {
			account: "Mon compte",
			confidentiality: "Confidentialité",
			contact: "Contact",
			logoff: "Déconnexion",
		},

		Stats: {
			projects_finished: "Projets publiés :",
			licenses: "Licences :",

			select_date: "Sélectionner une période",
			last_month: "30 derniers jours",

			dashboard_tab: "Tableau de bord",

			connections_tab: "Nombre de connexions",
			connections_title: "Connexions",
			connections: "Connexions",

			features_tab: "Principales fonctionnalités",
			features_title: "Cumul des fonctionnalités utilisés par date",
			features: "Fonctionnalités",
			preview: "Prévisualisations",
			finalisation: "Finalisations",
			cut: "Découpes",
			append: "Ajouts de vidéos",
			subtitles: "Sous-titres",

			geolocation_tab: "Localisation",
			tickets_tab: "Ouvertures tickets",
			licenses_tab: "Licences",

			email_col: "Adresse email",
			name_col: "Nom",
			date_col: "Date de création",
			state_col: "État",

			add_license: "Ajouter une licence",
			add_license_button: "Ajouter",
		},
		Tickets: {
			open: "Ouvert",
			resolved: "Résolu",
		},

		VideoLibrary: {
			featureNotFound: "Vous n'avez pas souscrit l'option Vidéothèque. Veuillez-nous contacter pour en savoir plus.",
			tab_title: "Administration",
			author: "Par ",
			search: "Rechercher : ",
		},
		Statistics: {
			tab_title: "Statistiques",
		},

		Report: {
			problem: "Signaler une défaillance",
			society: "Nom de votre société et de votre application :",
			date: "Date de l'incident :",
			mail: "Mail de la personne concernée par l'incident :",
			support: "Support :",
			model: "Modèle :",
			osversion: "Version d'OS :",
			incident: "Informations sur l'incident",
			context: "Contexte :",
			thematic: "Thématique :",
			detail: "Détail :",
			comments: "Commentaires :",

			modal_title: "Signalement effectué.",
			modal_message: "Votre signalement a bien été enregistré.",

			default_option: "Veuillez choisir une option.",
			send: "Envoyer",

			Support: {
				"support_mobile": "Application mobile",
				"support_web": "Plateforme web",
				"support_both": "Application mobile et plateforme web",
			},

			Context: {
				"context_mobile_conn": "Problème de connexion application",
				"context_mobile_editor": "Création ou modification de vidéo application",
				"context_web_conn": "Problème de connexion plateforme",
				"context_web_editor": "Création ou modification de vidéo dans la plateforme",
				"context_both_conn": "Problème de dialogue application plateforme",
			},

			Thematic: {
				"thematic_mobile_conn_wronglogin": "Mes identifiants de connexion ne fonctionnent pas",
				"thematic_mobile_editor_interview": "Difficulté dans la thématique interview",
				"thematic_mobile_editor_reportage": "Difficulté dans la thématique reportage",
				"thematic_web_conn_wronglogin": "Mes identifiants de connexion ne fonctionnent pas",
				"thematic_web_editor_newvid": "Je ne peux pas créer de nouvelle vidéo",
				"thematic_web_editor_interview": "Difficulté dans la thématique interview",
				"thematic_web_editor_reportage": "Difficulté dans la thématique reportage",
				"thematic_both_conn_export": "Je ne peux pas a envoyer un projet vidéo vers la plateforme",
				"thematic_both_conn_mail": "Je ne peux pas a envoyer un projet vidéo par mail",
			},

			Detail: {
				"detail_both_conn_export_notsending": "Je visualise bien ma vidéo finale sur mon téléphone mais quand je clic sur envoyer à la plateforme, rien ne se passe.",

				"detail_both_conn_mail_notsending": "Je visualise bien ma vidéo finale sur mon téléphone mais quand je clic sur envoyer par mail, rien ne se passe.",

				"detail_mobile_editor_interview_stepedit": "Je n'arrive pas à modifier une étape",
				"detail_mobile_editor_interview_stepvalid": "Une de mes étapes ne se valide pas dans la création",
				"detail_mobile_editor_interview_steprepview": "Je n'arrive pas à prévisualiser un étape",
				"detail_mobile_editor_interview_voice": "La voix off fonctionne mal",
				"detail_mobile_editor_interview_rush": "Je n'arrive pas à créer un nouveau rush",
				"detail_mobile_editor_interview_duplicate": "Je n'arrive pas à dupliquer une étape",
				"detail_mobile_editor_interview_subtitles": "Les sous-titrages ne s'affichent pas",
				"detail_mobile_editor_interview_translation": "La traduction ne s'affiche pas",
				"detail_mobile_editor_interview_nofinal": "La compilation finale ne fonctionne pas",
				"detail_mobile_editor_interview_wrongfinal": "Les étapes compilées ne sont pas les bonnes",

				"detail_mobile_editor_reportage_stepedit": "Je n'arrive pas à modifier une étape",
				"detail_mobile_editor_reportage_stepvalid": "Une de mes étapes ne se valide pas",
				"detail_mobile_editor_reportage_steprepview": "Je n'arrive pas à prévisualiser une étape",
				"detail_mobile_editor_reportage_voice": "La voix off fonctionne mal",
				"detail_mobile_editor_reportage_infography": "L'insertion d'infographie fonctionne mal",
				"detail_mobile_editor_reportage_rush": "Je n'arrive pas à créer un nouveau rush",
				"detail_mobile_editor_reportage_duplicate": "Je n'arrive pas à dupliquer une étape",
				"detail_mobile_editor_reportage_subtitles": "Les sous-titrages ne s'affichent pas",
				"detail_mobile_editor_reportage_translation": "La traduction ne s'affiche pas",
				"detail_mobile_editor_reportage_nofinal": "La compilation finale ne fonctionne pas",
				"detail_mobile_editor_reportage_wrongfinal": "Les étapes compilées ne sont pas les bonnes",

				"detail_web_editor_interview_stepedit": "Je n'arrive pas à modifier les titres d'une étape",
				"detail_web_editor_interview_editsubtitles": "Je n'arrive pas à modifier les sous-titres",
				"detail_web_editor_interview_gensubtitles": "Je n'arrive pas à générer des sous-titres",
				"detail_web_editor_interview_cut": "J'ai un souci avec la découpe d'un plan",
				"detail_web_editor_interview_insertvideo": "J'ai un souci avec l'insertion d'une nouvelle vidéo",
				"detail_web_editor_interview_insertcut": "J'ai un souci avec l'insertion d'un plan de coupe",
				"detail_web_editor_interview_infography": "J'ai un souci avec l'insertion d'infographie",
				"detail_web_editor_interview_addstep": "Je n'arrive pas à ajouter une étape",
				"detail_web_editor_interview_nosubtitles": "Les sous-titrages ne s'affichent pas à ma prévisualisation",
				"detail_web_editor_interview_notranslation": "La traduction ne s'affiche pas",
				"detail_web_editor_interview_nofinal": "La compilation finale ne fonctionne pas",
				"detail_web_editor_interview_wrongfinal": "Les étapes compilées ne sont pas les bonnes",
				"detail_web_editor_interview_badfinal": "La compilation est incomplète",
				"detail_web_editor_interview_sound": "Il existe un décalage son / image",

				"detail_web_editor_reportage_stepedit": "Je n'arrive pas à modifier les titres d'une étape",
				"detail_web_editor_reportage_editsubtitles": "Je n'arrive pas à modifier les sous-titres",
				"detail_web_editor_reportage_gensubtitles": "Je n'arrive pas à générer des sous-titres",
				"detail_web_editor_reportage_cut": "J'ai un souci avec la découpe d'un plan",
				"detail_web_editor_reportage_insertvideo": "J'ai un souci avec l'insertion d'une nouvelle vidéo",
				"detail_web_editor_reportage_insertcut": "J'ai un souci avec l'insertion d'un plan de coupe",
				"detail_web_editor_reportage_infography": "J'ai un souci avec l'insertion d'infographie",
				"detail_web_editor_reportage_addstep": "Je n'arrive pas à ajouter une étape",
				"detail_web_editor_reportage_nosubtitles": "Les sous-titrages ne s'affichent pas à ma prévisualisation",
				"detail_web_editor_reportage_notranslation": "La traduction ne s'affiche pas",
				"detail_web_editor_reportage_nofinal": "La compilation finale ne fonctionne pas",
				"detail_web_editor_reportage_wrongfinal": "Les étapes compilées ne sont pas les bonnes",
				"detail_web_editor_reportage_badfinal": "La compilation est incomplète",
				"detail_web_editor_reportage_sound": "Il existe un décalage son / image",
			},
		},
		form_labels: {
			soussigne: "Signataire :",
			birthdate: "né(e) le",
			address: "demeurant",
			minor: "Si l'autorisation concerne l'image d'un mineur, prénoms et noms :",
			capacity: "Agissant en qualité de",
			email_address: "Adresse mail du signataire",
			referent_email_address: "Votre adresse mail",
			filming: "Le",
			place: "Fait à",
			thematic: "Pour une vidéo avec la thématique",
			subject: "Intitulée de l'œuvre audiovisuelle, provisoirement ou définitivement :",
		},
		form_placeholders: {
			soussigne: "Prénoms et noms",
			birthdate: "Date de naissance",
			address: "Rue / Code postal / Ville",
			minor: "Prénoms et noms",
			capacity: "Fonction et nom de la société",
			email_address: "Adresse mail",
			referent_email_address: "Adresse mail",
			place: "Lieu",
			thematic: "Thématique de la vidéo",
			subject: "Nom de la vidéo",
		},
		form_logic: {
			reset_button: "Effacer",
			submit_button: "Envoyer",
			back_button: "Retour",
			undo_button: "Annuler",
			print_button: "Imprimer",
		},
		form: {
			title: "AUTORISATION D'ENREGISTREMENT D'IMAGES ET VOIX",
			mail_notice: "Une copie de ce formulaire vous sera envoyé à l'adresse spécifiée.",
			agreement_description: {
				t0: "Autorisation de Droits à l'Image",
				p01: "Je donne expressément mon autorisation à"
					+ " " + __CLIENT_NAME__ + ", société en commandite par actions au capital de ______ Euros, inscrite au Registre"
					+ " du Commerce et des Sociétés de ______ sous le numéro ______, ayant son siège social"
					+ " situé ______, France et ses sociétés affiliées"
					+ " (ci-après désignées par « ______ »), d'exploiter mon image et ce, selon les conditions ci-après précisées.",

				t1: "1 - Autorisation d'enregistrement",
				p11: "J'autorise " + __CLIENT_NAME__ + " à enregistrer mon image dans le cadre de la production et la diffusion de"
					+ " l'œuvre audiovisuelle suscitée.",
				p12: "Dans ce cadre, je consens à être filmé(e) et/ou photographié(e).",

				t2: "2 – Formes et finalités de l'exploitation",
				p21: "Par la présente, j'autorise " + __CLIENT_NAME__ + " à utiliser et exploiter mon image, par reproduction et/ou représentation de celle-ci, dans le cadre de la communication au public précisée au paragraphe 1 ci-dessus, à des fins de communication interne et externe, d'illustration, de promotion et/ou de publicité.",
				p22: "Dans le cas où " + __CLIENT_NAME__ + " souhaiterait exploiter mon image sous une forme ou dans une finalité non prévue aux présentes, " + __CLIENT_NAME__ + " me contactera afin d'obtenir une nouvelle autorisation de ma part. Toutefois, j'autorise d'ores et déjà la réutilisation de l'œuvre audiovisuelle contenant mon image, que ce soit en tout ou partie, dans une autre œuvre audiovisuelle à des fins de communication interne et externe, d'illustration, de promotion et/ou de publicité quelque soit le support de diffusion web, média, print... (internet, réseau social, intranet, projection événementiel...).",

				t3: "3 – Étendue et durée de l'autorisation",
				p31: "La présente autorisation est consentie à " + __CLIENT_NAME__ + " pour le monde entier et pour une durée de cinq (5) ans.",
				p32: "Cette autorisation sera renouvelable par tacite reconduction pour une durée de 5 ans, sauf dénonciation écrite de ma part adressée à " + __CLIENT_NAME__ + ".",

				t4: "4 – Commentaires et légendes utilisés lors de la diffusion de l'image",
				p41: __CLIENT_NAME__ + " veillera à ce que les éventuels commentaires accompagnant la diffusion de mon image ne portent en aucune manière atteinte à ma réputation, à mon honneur ou à ma dignité.",

				t5: "5 – Images fixes tirées d'une video",
				p51: "Le cas échéant, j'autorise expressément l'exploitation d'images arrêtées ou de captures d'écran qui seraient tirées de l'enregistrement vidéo susvisé dans le cadre de la communication au public précisée au paragraphe 1 ci-dessus.",

				t6: "6 – Circulation de l'autorisation",
				p61: __CLIENT_NAME__ + " pourra transférer, en tout ou partie, à tout tiers de son choix la présente autorisation aux fins de la réalisation et/ou de l'enregistrement de mon image et/ou de l'exploitation de celle-ci et ce, dans le respect des stipulations et de la finalité de la présente autorisation.",

				t7: "7 – Autorisation a titre gratuit",
				p71: "La présente autorisation d'exploitation de mon image est conférée à titre gratuit et sans contrepartie. Je renonce en conséquence à réclamer à " + __CLIENT_NAME__ + " et à tout tiers autorisé par " + __CLIENT_NAME__ + " une quelconque rémunération ou indemnité au titre de l'exploitation de mon image dans les conditions définies aux présentes.",

				t8: "8 – Droit d'auteur",
				p81: __CLIENT_NAME__ + " disposera de toute liberté dans le choix des images, du montage et des coupes éventuelles, sous réserve du respect de mon image.",
				p82: "Je reconnais que je ne pourrai prétendre disposer d'aucun droit d'auteur et/ou d'artiste interprète sur les vidéos et/ou photographies réalisées dans le cadre de la présente autorisation, du fait de l'utilisation de mon image par " + __CLIENT_NAME__ + " au sein de celles-ci.",
			},
		},
		interactions: {
			wait_for_project: "Veuillez patienter durant la création de votre projet.",
			submit_confirmation: "Voulez-vous réellement transmettre les informations entrées ?\n",
			submit_error: "Une erreur a eu lieu lors de l'envoi du formulaire. Merci de vérifier votre accès internet et réessayer dans quelques minutes.\n\n Si le problème persiste, veuillez contacter l'administrateur du service.",
			already_exists: "L'utilisateur est déjà inscrit pour la thématique à la date précisée.\n\nUne autre personne peut remplir le formulaire.\n",
			server_error: "Une erreur a eu lieu lors du traitement des informations par le serveur. Veuillez réessayer, et si le problème persiste, merci de contacter l'administrateur du serveur.\n",
			success: "Un mail avec la confirmation d'autorisation au droit à l'image a été envoyé.\n\nUne autre personne peut remplir le formulaire.\n",
			unknown_error: "Une erreur inconnue a eu lieu lors du traitement des informations par le serveur. Veuillez réessayer, et si le problème persiste, merci de contacter l'administrateur du serveur.\n",
		},
		VideoPrivacy: {
			exportAllButtonText: "Exporter l'ensemble de la liste",
			addPersonButtonText: 'Ajouter une nouvelle personne',
			nameColumn: 'Nom & prénom',
			mailColumn: 'Adresse mail',
			date: 'Date',
			thematic: 'Thématique',
			consultDocument: 'Consulter / Imprimer',
			deleteDocument: 'Supprimer',
		},
		VideoEdition: {
			fileType: "Le type de fichier sélectionné ne correspond pas. Veuillez insérer une vidéo",
			validCut: "Valider les modifications",
			suppress: "Annuler",
			insert: "Insérer",
			append: "Ajouter à la fin",
			appendbefore: "Ajouter au début",
			duration: "Durée :",
			maxInsertDuration: "Le plan de coupe à insérer ne peut pas avoir une durée supérieure à celle de votre vidéo originale.",
			selectCutingLabel: "Ajouter une vidéo (ou image) en gardant le son de la vidéo d'origine",
			selectCutingPlan: "Sélection",
			selectAppendLabel: "Insérer une vidéo supplémentaire dans la séquence",
			selectAppend: "Sélection",
		},
		Button: {
			disable_tooltip: "Désactiver l'aide au survol",
			enable_tooltip: "Activer l'aide au survol",
			loading: "Veuillez patienter pendant l'enregistrement de vos données",
			loader: 'Chargement...',
			preview: "Prévisualiser",
			preview_subtitles: "Prévisualiser les sous-titres",
			editing: 'en cours de modification...',
			loading_preview: 'Veuillez patienter pendant la génération de la prévisualisation...',
			validate_selection: "Valider",
			validate: "Valider les modifications",
			import: "Importer une vidéo",
			cut: "Découper ma vidéo",
			reset: "Réinitialiser",
			import_sequence: "Importer un contenu dans ma séquence",
			cancel: "Revenir à la vidéo d'origine",
			modifications: "Annuler les modifications",
			cancel_cut: "Annuler",
			cancel_sub: "Suite",
			syncsubs_message: "Veuillez patienter pendant la synchronisation de vos sous-titres...",
			syncsubs_message2: "Veuillez patienter pendant la synchronisation de votre vidéo et de vos sous-titres. Merci de ne pas fermer cette fenêtre.",
			syncsubs: "Synchroniser les sous-titres",
			edit_subtitles: "Editer les sous-titres",
			add_subtitles: "Ajouter des sous-titres",
			mute: "Couper le son",
			enable_music: "Activer la musique",
			volume_music: "Volume de la musique :",
		},
		Tooltip: {
			cut_message: "Découpez des parties de votre vidéo pour la raccourcir. Vous pouvez aussi insérez une vidéo en tant que plan de coup.",
			import_message: "Importer une vidéo dans votre projet",
			subtitle_import: "Générez automatiquement des sous-titres et traductions ou importez vous même un fichier de sous-tirages, selon les préconisations données.",
			insert: "",
			cut: 'La partie retirée sera celle entre les deux points. Une fois votre découpe faite, vous devez valider "définitivement" en cliquant sur "valider les modifications" avant de pouvoir faire une nouvelle découpe.',
			insertion: "Ajouter une vidéo qui sera ajoutée (sans audio) au dessus de la vidéo originale. L'audio de la vidéo originale est préservé.",
			message_wait: "Patience... cela peut prendre quelques instants selon la tâche demandée et la qualité de votre connexion internet.",
		},
		Errors: {
			error: 'Erreur',
			shareNotAllowed: 'Fonction de partage non disponible sur cette plateforme',
			maxOutrosSelected: "Vous ne pouvez pas sélectionner plus d'une vidéo pour votre étape Outro. Veuillez recommencer svp.",
			maxWatermarksSelected: "Vous ne pouvez pas sélectionner plus d'une vidéo pour votre étape Watermark. Veuillez recommencer svp.",
			videoFormatNotALlowed: "Merci d'insérer une nouvelle vidéo.",
			savingData: "Une erreur est survenue durant cette opération. "
				+ "Merci de nous contacter, et veuillez nous excuser pour la gêne occasionnée.",
			retrieving: "Une erreur est survenue lors de la récupération des données. "
				+ "Merci de nous contacter, et veuillez nous excuser pour la gêne occasionnée.",
			noStep: "Vous ne pouvez pas finaliser votre projet si ce dernier ne contient pas d'étapes.",
			error_detailed: "Une erreur est survenue durant cette opération.\n"
				+ "Merci de nous contacter, et veuillez nous excuser pour la gêne occasionnée.\nErreur : ",
			message_general: "N'hésitez pas à contacter notre équipe support en mentionnant votre souci et en indiquant : votre identifiant de connexion, un bref descriptif du souci rencontré ainsi que les coordonnées pour vous recontacter à appli@enjoyb.fr ou au 02.85.52.40.46.\nErreur : ",
			message_project: "N'hésitez pas à contacter notre équipe support en mentionnant votre souci et en indiquant : votre identifiant de connexion, le numéro de projet (en fin d'url) et son titre, un bref descriptif du souci rencontré ainsi que les coordonnées pour vous recontacter à appli@enjoyb.fr ou au 02.85.52.40.46.\nErreur : ",
		},
		Edition: {
			select_insert: "Sélectionnez une vidéo ou image à insérer",
			too_short: "La vidéo à insérer ne peut pas être plus longue que la vidéo originale.",
			insert: "Insérer",
			delete: "Supprimer",
			valid_cut: "Valider les modifications",
			wrong_type: "Mauvais type de fichier.Veuillez sélectionner une vidéo ou une image.",
		},
		Title: {
			title: "Titre",
			secondary_title: "Titre secondaire",
		},
		Speech: {
			title: "Prénoms et noms",
			secondary_title: "Fonction",
			keywords: "Jusqu'à trois mots-clefs séparés par des points virgules",
		},
		Images: {
			title: "Texte affiché",
			position: "Position",
			topleft: "En haut à gauche",
			topright: "En haut à droite",
			bottomleft: "En bas à gauche",
			bottomright: "En bas à droite",
		},
		Music: {
			select: "Sélectionnez la musique de cette vidéo",
			import: "Importer un fichier",
		},
		Subtitles: {
			export: "Exporter des sous-titres",
			import: "Importer des sous-titres",
			generate: "Générer des sous-titres",
			error_no_video: "Vous ne pouvez pas traduire cette étape car aucune vidéo n'est présente.",
			error_no_lang: "Vous ne pouvez pas n'avoir aucune langue de destination pour générer des sous-titres.",
		},
		Ambiance: {
			title: "Titre",
			secondary_title: "Titre secondaire",
			keywords: "Jusqu'à trois mots-clefs séparés par des points virgules",
			insertVoiceOverButtonText: "Insérer une voix-off",
		},
		Detail: {
			title: 'Titre',
			content: 'Description (Max 8 lignes)',
			subContent: 'Saisissez votre texte à faire apparaître dans l\'étape',
			validButtonText: 'Valider les modifications',
		},
		Final: {
			select: "Sélectionnez les étapes à compiler :",
			finalise: "Finaliser",
			export_1080hd: "Montage automatique en paysage",
			export: "Montage automatique",
			export_1080sq: "Montage automatique en carré",
			export_1200sq: "Montage automatique en carré",
		},
		Keynum: {
			number: "Chiffre clé",
			explanation: "Explication",
		},
		Infographic: {
			title: "Titre",
			upload: "Importer une image",
		},

		Login: {
			password: "Mot de passe",
			login: "Connexion",
			userNotFound: "L'identifiant et le mot de passe ne correspondent pas. Veuillez recommencer",
			notAllowed: "Vous n'êtes pas autorisé à vous connecter à cette plateforme",
			licenseObsoleteTitle: "Licence expirée",
			licenseObsolete: "Vous n'avez plus accès à cet outil. Pour continuer à utiliser ces services, il est nécessaire de renouveler votre licence.",
			empty: "L'identifiant et le mot de passe ne peuvent pas être vides. Veuillez recommencer...",
			orderLicense: "Envoyer une demande de renouvellement",
			buyLicense: "Acheter une licence",
			licenseRenewTitle: "Demande envoyée",
			licenseRenew: "Votre demande de renouvellement a bien été envoyée.",
		},
	},
	'en-GB': {
		recrutement: "Recruiting",
		communication: "Communication",

		current_lang: "en",
		date_locale: "en-GB",
		new_project_image: "./static/images/new.png",

		months: {
			1: "january",
			2: "february",
			3: "march",
			4: "april",
			5: "may",
			6: "june",
			7: "july",
			8: "august",
			9: "september",
			10: "october",
			11: "november",
			12: "december",
		},

		StepsList: {
			Titre: "Title (optional)",
			Environnement_de_linterview: "Interview background (optional)",
			Intertitle: "Intertitle (optional)",
			Intertitle_2: "Intertitle (optional)",
			Intertitle_3: "Intertitle (optional)",
			Interview: "Interview (optional)",
			Interview_2: "Interview 2 (optional)",
			Interview_3: "Interview 3 (optional)",
			Interview_4: "Interview 4 (optional)",
			Ambiance: "Wide shot (optional)",
			Ambiance_2: "Wide shot 2 (optional)",
			Ambiance_3: "Wide shot 3 (optional)",
			Ambiance_4: "Wide shot 4 (optional)",
			Infographie: "Infography (optional)",
			Infographie_2: "Infography 2 (optional)",

			Second_ambiance: "Wide shot (optional)",
			Final_interview: "Final Interview (optional)",

			Music: "Music (optional)",
			Watermark: "Watermark (optional)",
			Outro: "Credits (optional)",
			Ambiance_keywords: "Keywords (optional)",

			Final: "Finish",
		},

		lang: {
			fr: "French",
			en: "English",
			es: "Spanish",
			false: "Without subtitles",
		},

		Account: {
			contact: "Contact",
			add_user: "Create a new account",
		},
		Dashboard: {
			project_list: "Video list",
			name: "Dashboard",
			labelImageRights: "Droit à l'image",
		},

		Navbar: {
			video_name: "Name of your video",
		},

		Menu: {
			account: "My account",
			confidentiality: "Confidentiality",
			contact: "Contact",
			logoff: "Logging off",
		},

		Stats: {
			projects_finished: "Published projects:",
			licenses: "Licenses:",

			select_date: "Select a period",
			last_month: "30 last days",

			dashboard_tab: "Dashboard",

			connections_tab: "Number of connexions",
			connections_title: "User connections",
			connections: "Connections",

			features_tab: "main features",
			features_title: "Amount of used features by date",
			features: "Features",
			preview: "Previews",
			finalisation: "Finitions",
			cut: "Cuts",
			append: "Video additions",
			subtitles: "Subtitles",

			geolocation_tab: "Location",
			tickets_tab: "Opened tickets",
			licenses_tab: "Licenses",

			email_col: "Email address",
			name_col: "Name",
			date_col: "Creation date",
			state_col: "State",

			add_license: "Add a license",
			add_license_button: "Add",
		},
		Tickets: {
			open: "Open",
			resolved: "Resolved",
		},

		VideoLibrary: {
			featureNotFound: "",
			tab_title: "Administration",
			author: "By ",
			search: "Search: ",
		},
		Statistics: {
			tab_title: "Statistics",
		},

		Report: {
			problem: "Report a problem",
			society: "Name of your society and of your application:",
			date: "Incident date:",
			mail: "Mail of the user who experienced the incident:",
			support: "Support:",
			model: "Model:",
			osversion: "OS version:",
			incident: "Information about the incident",
			context: "Context:",
			thematic: "Thematic:",
			detail: "Detail:",
			comments: "Comments:",

			modal_title: "Report done.",
			modal_message: "Your report was registered.",

			default_option: "Please choose an option.",
			send: "Send",

			Support: {
				"support_mobile": "Mobile application",
				"support_web": "Web platform",
				"support_both": "Mobile application and web platform",
			},

			Context: {
				"context_mobile_conn": "Login problem on the mobile app",
				"context_mobile_editor": "Video creation or video edition on the mobile app",
				"context_web_conn": "Login problem on the web app",
				"context_web_editor": "Video creation or video edition on the web app",
				"context_both_conn": "Communication problem between the mobile app and the web platform",
			},

			Thematic: {
				"thematic_mobile_conn_wronglogin": "My login details don't work",
				"thematic_mobile_editor_interview": "Difficulties with the interview thematic",
				"thematic_mobile_editor_reportage": "Difficulties with the reportage thematic",
				"thematic_web_conn_wronglogin": "My login details don't work",
				"thematic_web_editor_newvid": "I can't create a new project",
				"thematic_web_editor_interview": "Difficulties with the interview thematic",
				"thematic_web_editor_reportage": "Difficulties with the reportage thematic",
				"thematic_both_conn_export": "I can't send a project to the web platform",
				"thematic_both_conn_mail": "I can't send a project via email",
			},

			Detail: {
				"detail_both_conn_export_notsending": "I can see the final video on my phone, but when I try to send it to the web platform, nothing happens.",

				"detail_both_conn_mail_notsending": "I can see the final video on my phone, but when I try to send it via email, nothing happens.",

				"detail_mobile_editor_interview_stepedit": "I'm unable to edit a step",
				"detail_mobile_editor_interview_stepvalid": "On of my step fails during the creation of my video",
				"detail_mobile_editor_interview_steprepview": "I can't preview a step",
				"detail_mobile_editor_interview_voice": "The voice-over doesn't work",
				"detail_mobile_editor_interview_rush": "I can't create a new rush",
				"detail_mobile_editor_interview_duplicate": "I'm unable to duplicate a step",
				"detail_mobile_editor_interview_subtitles": "The subtitles aren't displayed",
				"detail_mobile_editor_interview_translation": "The translation isn't displayed",
				"detail_mobile_editor_interview_nofinal": "The final compilation doesn't work",
				"detail_mobile_editor_interview_wrongfinal": "The compiled steps aren't the right ones",

				"detail_mobile_editor_reportage_stepedit": "I'm unable to edit a step",
				"detail_mobile_editor_reportage_stepvalid": "On of my step fails during the creation of my video",
				"detail_mobile_editor_reportage_steprepview": "I can't preview a step",
				"detail_mobile_editor_reportage_voice": "The voice-over doesn't work",
				"detail_mobile_editor_reportage_infography": "Infographics insertion works poorly",
				"detail_mobile_editor_reportage_rush": "I can't create a new rush",
				"detail_mobile_editor_reportage_duplicate": "I'm unable to duplicate a step",
				"detail_mobile_editor_reportage_subtitles": "The subtitles aren't displayed",
				"detail_mobile_editor_reportage_translation": "The translation isn't displayed",
				"detail_mobile_editor_reportage_nofinal": "The final compilation doesn't work",
				"detail_mobile_editor_reportage_wrongfinal": "The compiled steps aren't the right ones",

				"detail_web_editor_interview_stepedit": "I'm unable to edit the fields of a step",
				"detail_web_editor_interview_editsubtitles": "I'm unable to edit the subtitles",
				"detail_web_editor_interview_gensubtitles": "I'm unable to generate subtitles",
				"detail_web_editor_interview_cut": "I have troubles making a cut",
				"detail_web_editor_interview_insertvideo": "I have troubles trying to insert a new video",
				"detail_web_editor_interview_insertcut": "I have troubles trying to insert a cutscene",
				"detail_web_editor_interview_infography": "I have troubles trying to insert an infographic",
				"detail_web_editor_interview_addstep": "I'm unable to add a step",
				"detail_web_editor_interview_nosubtitles": "Subtitles aren't displayed during preview",
				"detail_web_editor_interview_notranslation": "The translation isn't displayed",
				"detail_web_editor_interview_nofinal": "The final compilation doesn't work",
				"detail_web_editor_interview_wrongfinal": "The compiled steps aren't the right ones",
				"detail_web_editor_interview_badfinal": "The final video isn't complete",
				"detail_web_editor_interview_sound": "There's an offset between the image and the sound",

				"detail_web_editor_reportage_stepedit": "I'm unable to edit the fields of a step",
				"detail_web_editor_reportage_editsubtitles": "I'm unable to edit the subtitles",
				"detail_web_editor_reportage_gensubtitles": "I'm unable to generate subtitles",
				"detail_web_editor_reportage_cut": "I have troubles making a cut",
				"detail_web_editor_reportage_insertvideo": "I have troubles trying to insert a new video",
				"detail_web_editor_reportage_insertcut": "I have troubles trying to insert a cutscene",
				"detail_web_editor_reportage_infography": "I have troubles trying to insert an infographic",
				"detail_web_editor_reportage_addstep": "I'm unable to add a step",
				"detail_web_editor_reportage_nosubtitles": "Subtitles aren't displayed during preview",
				"detail_web_editor_reportage_notranslation": "The translation isn't displayed",
				"detail_web_editor_reportage_nofinal": "The final compilation doesn't work",
				"detail_web_editor_reportage_wrongfinal": "The compiled steps aren't the right ones",
				"detail_web_editor_reportage_badfinal": "The final video isn't complete",
				"detail_web_editor_reportage_sound": "There's an offset between the image and the sound",
			},
		},
		form_labels: {
			soussigne: "Signatory:",
			birthdate: "born on",
			address: "residing at",
			minor: "if the authorisation relates to an image of a minor, full name:",
			capacity: "Acting as",
			email_address: "Signatory mail address",
			referent_email_address: "Your mail address",
			filming: "On",
			place: "Done at",
			thematic: "For a video with the theme",
			subject: "Audiovisual work entitled, provisionally or permanently:",
		},
		form_placeholders: {
			soussigne: "Full Name",
			birthdate: "Birthdate",
			address: "Street / ZIP code / City",
			minor: "Full Name",
			capacity: "Position and name of the company",
			email_address: "Mail address",
			referent_email_address: "Mail address",
			place: "place",
			thematic: "Video's thematic",
			subject: "Video's name",
		},
		form_logic: {
			reset_button: "Reset",
			submit_button: "Submit",
			back_button: "Go back",
			undo_button: "Undo",
			print_button: "Print",
		},
		form: {
			title: "AUTHORIZATION FOR USE OF IMAGE AND VOICE",
			mail_notice: "A copy of this form will be sent to the provided email address.",
			agreement_description: {
				t0: "Image Rights Authorisation",
				p01: "I expressly give my authorisation to " + __CLIENT_NAME__ + ", a partnership limited by shares having capital of EUR ______,"
					+ " entered in the Commercial and Companies Register (RCS) of ______ under number ______,"
					+ " having its registered office located at ______, France, and its affiliated companies"
					+ " (hereinafter referred to collectively as “" + __CLIENT_NAME__ + "”), to use my image, under the conditions set out below.",

				t1: "1 - Autorisation for recordings",
				p11: "I authorise " + __CLIENT_NAME__ + " to record my image in the context of the production and broadcast of the audiovisual work",
				p12: "In this context, I consent to being filmed and/or photographed.",

				t2: "2 – Forms and purposes of the use",
				p21: "By virtue of the present authorisation, I authorise " + __CLIENT_NAME__ + " to use and exploit my image, via the reproduction and/or representation thereof, in the context of the communication to the public specified in paragraph 1 above, for the purposes of internal and external communication, of illustration, of promotion and/or of advertising.",
				p22: "In the event that " + __CLIENT_NAME__ + " wishes to use my image in a form or for a purpose not provided for in these presents, " + __CLIENT_NAME__ + " shall contact me in order to obtain new authorisation from me. However, I hereby authorise the reuse of the audiovisual work containing my image, either in whole or in part, in another audiovisual work for the purposes of internal and external communication, of illustration, of promotion and/or of advertising whatever the medium of web diffusion, media, print ... (internet, social network, intranet, projection event ...).",

				t3: "3 – Scope and duration of the authorisation",
				p31: "The present authorisation is granted to " + __CLIENT_NAME__ + " in respect of the whole world and for a duration of 5 years.",
				p32: "This authorisation shall be renewable by way of tacit agreement for a period of 5 years, unless I give written notice of termination to " + __CLIENT_NAME__ + ".",

				t4: "4 – Comments and captions used when broadcasting the image",
				p41: __CLIENT_NAME__ + " shall ensure that any comments accompanying the broadcast of my image do not harm my reputation, honour or dignity in any way.",

				t5: "5 – Still images taken from a video",
				p51: "Where applicable, I expressly authorise the use of still images or screen captures that may be taken from the video recording referred to above in the context of the communication to the public specified in paragraph 1 above.",

				t6: "6 – Circulation of the authorisation",
				p61: __CLIENT_NAME__ + " shall be able to transfer, in whole or in part, the present authorisation to any third party of its choice for the purpose of producing and/or recording my image and/or using it, in compliance with the stipulations and purpose of the present authorisation.",

				t7: "7 – Authorisation granted free of charge",
				p71: "The present authorisation to use my image is granted free of charge and for no consideration. I therefore waive the right to claim from " + __CLIENT_NAME__ + " and any third party authorised by " + __CLIENT_NAME__ + " any remuneration or compensation whatsoever for the use of my image under the conditions defined in these presents.",

				t8: "8 – Copyright",
				p81: __CLIENT_NAME__ + " shall have complete freedom in the choice of images, editing and any cropping, provided that my image is respected.",
				p82: "I acknowledge that I shall not be able to claim to have any copyrights and/or performers' rights over the videos and/or photographs produced within the framework of the present authorisation due to the use of my image by " + __CLIENT_NAME__ + " within those videos and/or photographs.",
			},
		},
		interactions: {
			wait_for_project: "Please wait while your project is created.",
			submit_confirmation: "Are you sure about the information you're going to send ?\n",
			submit_error: "An error occurred during the sending of your information. Please check your internet access and try again in a few minutes.\n\n If the problem persists, please contact the server administrator.",
			already_exists: "The person is already registered for the submitted thematic and date\n\nAnother person can complete the form\n",
			server_error: "An error happened during data processing by the server. Please try again, and if the problem persists, please contact the server administrator.\n",
			success: "An email has been sent with image rights authorization confirmation.\n\nAnother person can complete the form.\n",
			unknown_error: "An unknown error happened during data processing by the server. Please try again, and if the problem persists, please contact the server administrator.\n",
		},
		VideoPrivacy: {
			exportAllButtonText: 'Export all',
			addPersonButtonText: 'Add new person',
			nameColumn: 'Lastname & firstname',
			mailColumn: 'Email',
			date: 'Date',
			thematic: 'Thematic',
			consultDocument: 'See / Print',
			deleteDocument: 'Delete',
		},
		VideoEdition: {
			fileType: "The selected file type does not match. Please insert a video.",
			validCut: "Validate my cut",
			suppress: "Cancel",
			insert: "Insert",
			append: "Append after",
			appendbefore: "Append before",
			duration: "Duration:",
			maxInsertDuration: "The cutting plan to be inserted can not last longer than your original video.",
			selectCutingPlan: "Selection cutting plan",
			selectAppend: "Selection video to append",
		},
		Button: {
			disable_tooltip: "Disable tooltips",
			enable_tooltip: "Enable tooltips",
			loading: "Please wait while your data is saved.",
			loader: 'Loading...',
			editing: 'editing...',
			loading_preview: 'Please wait while we generate your preview...',
			validate_selection: "Validate",
			validate: "Validate the modifications",
			preview: "Preview",
			preview_subtitles: "Preview subtitles",
			import: "Import a video",
			cut: "Cut my video",
			reset: "reset",
			import_sequence: "Import content",
			cancel: "Return to the original video",
			cancel_cut: "Cancel",
			cancel_sub: "Next",
			syncsubs_message: "Please wait while we synchronise your subtitles...",
			syncsubs: "Synchronise subtitles",
			edit_subtitles: "Edit subtitles",
			add_subtitles: "Add subtitles",
			mute: "Mute sound",
			enable_music: "Enable music",
			volume_music: "Music volume:",
		},
		Tooltip: {
			cut_message: "Cut parts of your video to make it shorter. You can also insert a video as a shot.",
			import_message: "Import a video into your project",
			subtitle_import: "Automatically generate subtitles and translations or import a subtitle file yourself, according to the recommendations given.",
			insert: "",
			cut: 'The part that will be removed is the one between the two red dots. Once your cut is done, you need to validate "définitively" by clicking the green "validate" button before you can make a new cut.',
			insertion: "Add a video that will be added (without audio) on top of your original video. The audio of the original video is preserved.",
		},
		Errors: {
			error: 'Error',
			shareNotAllowed: "Sharing options unavailable on this app.",
			maxOutrosSelected: "You cannot select more than one video at once for this step. Please select only one.",
			maxWatermarksSelected: "You cannot select more than one watermark.",
			videoFormatNotALlowed: "Please add a new video.",
			savingData: "An error occurred during this operation"
				+ "Please contact us so we can assist you. We apologise for the inconvenience.",
			error_detailed: "An error occurred during this operation.\n"
				+ "Please contact us so we can assist you. We apologise for the inconvenience.\nError:",

			noStep: "You cannot finish a project without any step.",
		},
		Edition: {
			select_insert: "Select a video to insert",
			too_short: "The video to insert can't be longer than the original video.",
			insert: "Insert",
			delete: "Delete",
			valid_cut: "Validate the change",
			wrong_type: "Wrong file type. Please select a video.",
		},
		Title: {
			title: "Title",
			secondary_title: "Secondary Title",
		},
		Speech: {
			title: "First and last names",
			secondary_title: "Function",
			keywords: "3 keywords (mandatory) separated by semicolons",
		},
		Ambiance: {
			title: "Title",
			secondary_title: "Secondary Title",
			keywords: "3 keywords (mandatory) separated by semicolons",
			insertVoiceOverButtonText: "Insert voice-over",
		},
		Images: {
			title: "Displayed text",
			position: "Position",
			topleft: "Top left",
			topright: "Top right",
			bottomleft: "Bottom left",
			bottomright: "Bottom right",
		},
		Keynum: {
			number: "Key number ",
			explanation: "Explanation ",
		},
		Infographic: {
			title: "Title",
			upload: "Import an image",
		},
		Subtitles: {
			export: "Export subtitles",
			import: "Import subtitles",
			generate: "Generate subtitles",
			error_no_video: "You cannot translate this step as it doesn't contain any video.",
			error_no_lang: "You must select a target language.",
		},
		Partners: {
			title: "Title",
			secondary_title: "Secondary Title",
			keywords: "3 keywords (mandatory) separated by semicolons",
			cancel: "Return to the original video",
			preview: "Preview",
		},
		Music: {
			select: "Select music for this video",
			import: "Import a file",
		},
		Detail: {
			title: 'Title',
			content: 'Description (Max 8 lines)',
			subContent: "Enter the text to to show in this step.",
			validButtonText: "Validate modifications",
		},
		Final: {
			select: "Select the steps to compile:",
			finalise: "Finalise",
			export_1080hd: "Export in landscape",
			export: "Export",
			export_1080sq: "Exporter in square",
		},

		Login: {
			password: "Password",
			login: "Sign-in",
			userNotFound: "The password or the id doesn't match to ours records. Please try again",
			notAllowed: "You are not allowed to connect to this platform",
			licenseObsoleteTitle: "License expired",
			licenseObsolete: "You don't have access to this app anymore. To continue using this service, it is necessary to renew your license.",
			empty: "Your password or id can't be empty. Please try again.",
			orderLicense: "Request a renewal",
			buyLicense: "Buy a license",
			licenseRenewTitle: "Request sent",
			licenseRenew: "Your renewal request has been sent.",
		},
	},
};

messages["fr"] = messages["fr-FR"];
messages["en"] = messages["en-GB"];

// EN disabled by force
delete messages["en"];
delete messages["en-GB"];

export default messages;
